import { render, staticRenderFns } from "./PageElderlyIns.vue?vue&type=template&id=ce120552&scoped=true&"
import script from "./PageElderlyIns.vue?vue&type=script&lang=js&"
export * from "./PageElderlyIns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce120552",
  null
  
)

export default component.exports